import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { StateToObj } from "./reduxHelper";

const initialState = {
    "id" : uuidv4(),
    "data": {}
}

const callIntermediateScreen = createSlice({
    name:'callIntermediateScreen',
    initialState,
    reducers:{
        addCallIntermediate: (_state,payload)=>{
            return {
            ..._state,
            "id" : uuidv4(),
            "data": {...StateToObj(_state).data,...payload.payload}
            }
        },
        resetCallIntermediate: (_state,payload)=>{
            return initialState;
     }
    }
});

export default callIntermediateScreen.reducer
export const addCallIntermediate = callIntermediateScreen.actions.addCallIntermediate
export const resetCallIntermediate = callIntermediateScreen.actions.resetCallIntermediate